import { StatsFileDto, StatsIndexDto } from "@domain";
import { IDtoCommandResults } from "@kernel/ddd";
import {
  BaseHttpService,
  HttpError,
  HttpRequest
} from "@kernel/frontend-react-app";

export class StatsRepositoryService extends BaseHttpService {
  constructor() {
    const fetch = HttpRequest.create("/api/stats");
    super(fetch);
  }

  public async load(room?: string): Promise<StatsIndexDto> {
    const query = room ? `?room=${room}` : "";
    const result = (await this.get(`/${query}`)) as IDtoCommandResults;
    if (!result.success && result.error) throw new HttpError(result.error);
    return result.item as StatsIndexDto;
  }

  public async getFile(name: string): Promise<StatsFileDto> {
    const result = (await this.get(`${name}`)) as IDtoCommandResults;
    if (!result.success && result.error) throw new HttpError(result.error);
    return result.item as StatsFileDto;
  }

  public async remove(name: string): Promise<StatsIndexDto> {
    // Workaround delete bug - TODO fix bug in base library
    try {
      await this.delete(`${name}`);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      // const [_, room] = name.split(".");
      return await this.load();
    } catch {
      return await this.load();
    }
  }
}
